import { render, staticRenderFns } from "./CraftIngredients.vue?vue&type=template&id=6894664d&scoped=true&"
import script from "./CraftIngredients.vue?vue&type=script&lang=ts&"
export * from "./CraftIngredients.vue?vue&type=script&lang=ts&"
import style0 from "./CraftIngredients.vue?vue&type=style&index=0&id=6894664d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6894664d",
  null
  
)

export default component.exports